function formatPrice(price, display = false, format = false) {
  if (!price)
    return null

  let result = ''

  if (display)
    result += '$'

  result += format ? price.toLocaleString('en-US', { style: 'currency', 'currency': 'USD' }) : price.toFixed(2)

  return result
}

export { formatPrice }